import { DashboardLink } from "@/components/Dashboard/Dashboard";
import { AddSvg, ManageSvg, PartsSvg } from "@/components/Icon/Icon";
import { UPLOAD_SCANS_MODAL } from "@/pages/Home/DesignSection/AssembledTabsSection/UploadScansModal/UploadScansModal";
import { selectModalOpen, setModalOpen } from "@/store/slices/modalSlice";
import { selectIsOutOfCredits, selectShownCreditWarning, setShownCreditWarning } from "@/store/slices/orgSlice";
import { store } from "@/store/store";
import { useTranslation } from "react-i18next";
import { trackCreateCaseDialogOpened } from "@/analytics/tracking";

const LoadLinks = () => {
  const { t } = useTranslation();

  const handleOnClickCreate = () => {
    const isOutOfCredits = selectIsOutOfCredits(store.getState());
    if (isOutOfCredits) {
      store.dispatch(setShownCreditWarning(false));
    } else {
      trackCreateCaseDialogOpened();
      store.dispatch(setModalOpen({ name: UPLOAD_SCANS_MODAL, value: true }));
    }
  };

  const PrimaryLinks: DashboardLink[] = [
    {
      name: t("common:links.create"),
      link: handleOnClickCreate,
      icon: <AddSvg color="inherit" />,
      requiresCredits: true,
      selectIsSelected: (state) =>
        selectModalOpen(state, UPLOAD_SCANS_MODAL) || (selectIsOutOfCredits(state) && !selectShownCreditWarning(state))
    },
    {
      name: t("common:links.designs"),
      link: "/cases",
      icon: <PartsSvg color="inherit" />
      //  TODO icon
    }
  ];

  const FooterLinks: DashboardLink[] = [
    {
      name: t("common:links.manage"),
      link: "/manage",
      icon: <ManageSvg color="inherit" />
    }
  ];

  return {
    PrimaryLinks,
    FooterLinks
  };
};

export { LoadLinks };
